import { render, staticRenderFns } from "./categoria.vue?vue&type=template&id=6a2999ad&scoped=true&"
import script from "./categoria.vue?vue&type=script&lang=js&"
export * from "./categoria.vue?vue&type=script&lang=js&"
import style0 from "./categoria.vue?vue&type=style&index=0&id=6a2999ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2999ad",
  null
  
)

export default component.exports